// @flow
import Loading from 'components/Loading'
import * as React from 'react'

type Props = {
  history: {
    replace: (path: string) => void,
  },
}

function SignupSuccess({ history }: Props): React.Node {
  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const redirectPath = urlParams.get('redirect') || '/'
    history.replace(redirectPath)
  }, [history])

  return <Loading />
}

export default SignupSuccess
